export default "__VITE_ASSET__DZBuCweX__"